import axios from "axios";

export const validateUserIdAlreadyExists = async (
  userId,
  corelationId,
  setUserIdExistsError
) => {
  try {
    await axios.get("/userCheck/", {
      headers: {
        target: "checkdob",
        "ga-request-id": corelationId,
        userId: userId,
      },
    });
    setUserIdExistsError(true);
  } catch (err) {
    setUserIdExistsError(false);
  }
};
